import { Routes, Route, Navigate } from 'react-router-dom';
import LegacyHealingLogin from './pages/Login';
import HomePage from './pages/HomePages';
import { AuthProvider, useAuth } from './AuthContext';

function AppRoutes() {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={<LegacyHealingLogin />} />
      <Route 
        path="/" 
        element={isAuthenticated ? <HomePage /> : <Navigate to="/login" replace />} 
      />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;